import React from 'react';
import SelectDropdown from './SelectDropdown';
import { useLanguage } from '../contexts/LanguageContext';
import { ManagedDepartment } from '../types';

interface DepartmentPickerProps {
  departments: ManagedDepartment[];
  value: number | null;
  onChange: (id: number) => void;
  error?: string;
}

/** Target-department choice. Renders nothing for single-department users. */
const DepartmentPicker: React.FC<DepartmentPickerProps> = ({ departments, value, onChange, error }) => {
  const { t, language } = useLanguage();
  if (departments.length <= 1) return null;

  return (
    <SelectDropdown
      label={t('common.targetDepartment')}
      placeholder={t('common.selectTargetDepartment')}
      required
      options={departments.map((d) => ({
        value: d.id,
        label: language === 'en' ? d.name_en || d.name : d.name,
      }))}
      value={value}
      onChange={(v) => onChange(Number(v))}
      error={error}
    />
  );
};

export default DepartmentPicker;
